import React from "react";

export const NotFound: React.FC<{}> = () => {
  return (
    <div>
      <h2>404 Not Found</h2>
    </div>
  );
};
